const images = {
    ic_logout: require('../icons/ic_logout.png'),
    ic_default_avatar: require('../icons/ic_default_avatar.png'),
    ic_input_file: require('../icons/ic_input_file.png'),
    ic_photo: require('../icons/ic_photo.png'),
    ic_send: require('../icons/ic_send.png'),
    ic_wave_hand: require('../icons/ic_wave_hand.png'),
    ic_info:require('../icons/info-24px.svg'),
    ic_description:require('../icons/description-24px.svg'),
}

export default images
